export default {
  buttons: {
    cancel: "prekliči",
    dismiss: "zapri",
    add_waypoint: "dodaj destinacijo"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "milje"
    }
  },
  search: {
    title: "Išči",
    placeholder: "vnesi lokacijo",
    enter_location: "vnesi lokacijo",
    geolocation: "uporabi mojo lokacijo",
    help: {
      inactive: "Išči"
    }
  },
  filters: {
    title: "filtri",
    amenities: {
      title: "Storitve in oprema"
    },
    fuels: {
      title: "tip goriva"
    }
  },
  directions: {
    title: "planer poti",
    placeholder: {
      destination: "vnesi lokacijo",
      waypoint: "vnesi lokacijo"
    },
    route: {
      title: "Opcije poti",
      avoid_tolls: "izogni se cestninam",
      avoid_highways: "izogni se avtocestam",
      title_corridor: "Razdalja od poti do črpalke"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# dan} other {# dnevi}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# minute}}\
`,
    button: "Iskanje"
  },
  locations: {
    title: "lokacije",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} od {place}"
  },
  info_window: {
    title: "detalji črpalke",
    location_id: "ID črpalke",
    services: "Storitve in oprema",
    nearby: "zraven",
    mobile: {
      telephone: "tel:"
    },
    opening_hours: {
      title: "odpiralni časi",
      mon: "pon",
      tue: "tor",
      wed: "sre",
      thu: "čet",
      fri: "pet",
      sat: "sob",
      sun: "ned",
      open_twentyfourhours: "odprto 24 ur",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "zadnja posodobitev",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "planer poti"
  },
  fuels: {
    adblue: "Ad Blue",
    shell_regular_diesel: "Diesel",
    super98: "Super 98",
    unleaded_super: "Super 95"
  },
  amenities: {
    air_and_water: "zrak",
    atm: "bankomat",
    austrian_highway_sticker: "avstrijska vinjeta",
    bank_note_acceptor: "avtomat za polaganje gotovine",
    bottled_gas: "n/a",
    cafe: "kavarna",
    carwash: "avtopralnica",
    clubsmart_card: "Shell ClubSmart kartica",
    costa_express: "n/a",
    credit_card_american_express: "kreditna kartica - American Express",
    credit_card_diners_club: "kreditna kartica - Diners Club",
    credit_card_mastercard: "kreditna kartica - Mastercard",
    credit_card_visa: "kreditna kartica - Visa",
    credit_card: "kreditna kartica",
    czech_highway_sticker: "češka vinjeta",
    disability_assistance: "pomoč invalidnim",
    euroshell_card: "euroShell kartica/Shell kartica",
    fleet_card_dkv: "n/a",
    fleet_card_eni: "n/a",
    fleet_card_esso: "n/a",
    fleet_card_general: "Fleet kartica",
    fleet_card_uta: "n/a",
    food_offerings: "ponudba hrane",
    full_service: "črpalka z osebjem",
    guarded_car_park: "varovano parkirišče",
    hgv_lane: "prijatno kamionistom",
    hot_food: "topla hrana",
    hungarian_highway_sticker: "madžarska vinjeta",
    ido_ticket: "Ido karta",
    maut_terminal: "n/a",
    mobile_payment: "mobilno plačevanje",
    parking_lanes: "parkirišče",
    partner_loyalty_accepted: "sprejem zvestobe partnerjev",
    pay_at_pump: "plačilo na črpalki",
    restaurant: "restavracija",
    self_service: "samopostrežni servis",
    service_bay: "n/a",
    shell_card: "euroShell kartica/Shell kartica",
    shell_club_smart_extra_card: "Shell ClubSmart Extra kartica",
    shop: "trgovina",
    shower: "tuši",
    slovak_highway_sticker: "slovaška vinjeta",
    snack_food: "prigrizki/hitra prehrana",
    standard_toilet: "WC",
    supermarket_fuel_discount: "popust na gorivo",
    toilet: "WC",
    truck_parking: "parkirišče za kamione",
    truckport: "le ta tovorna vozila",
    twenty_four_hour: "24 ur",
    unmanned: "brez osebja",
    vacuum: "sesalec",
    vehicle_identity_system: "sistem za identifikacijo vozila",
    wifi: "Wi-Fi"
  },
  settings: {
    title: "nastavitve",
    tooltip: "nastavitve",
    distance_units: {
      title: "razdalja",
      km: "kilometri",
      miles: "milje"
    },
    language: {
      title: "jezik"
    }
  },
  geolocation: {
    tooltip: "uporabi mojo lokacijo"
  }
}
